import { FlightUpdatesLog } from "@/components/admin/FlightUpdatesLog";

export default function FlightUpdatesPage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Real-time Flight Updates</h2>
        <p className="text-muted-foreground">Monitor all flight changes and updates across organizations</p>
      </div>
      <FlightUpdatesLog />
    </div>
  );
}
